// extracted by mini-css-extract-plugin
module.exports = {"modalPromotion":"ModalCardFlashDeals_modalPromotion__2snTm"};